import { render, staticRenderFns } from "./modalActivarTienda.vue?vue&type=template&id=3ddb54fc&"
import script from "./modalActivarTienda.vue?vue&type=script&lang=js&"
export * from "./modalActivarTienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports